module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"title":"Topology","namespaces":{"current":"Current namespace","label":"Selected namespace"}}}')
  delete Component.options._Ctor
}
